import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { useI18n } from '../i18n/index.jsx';

export default function Library() {
  const [showModal, setShowModal] = useState(false);
  const email = typeof window !== 'undefined' ? (localStorage.getItem('email') || 'vous') : 'vous';
  const { t, locale } = useI18n();

  const openComingSoon = () => setShowModal(true);

  return (
    <DashboardLayout>
  <div className="flex-1 overflow-auto min-h-screen">
        <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-emerald-500/25 blur-3xl hidden md:block" />
        <div className="pointer-events-none absolute bottom-[-90px] right-[-90px] h-96 w-96 rounded-full bg-sky-500/20 blur-3xl hidden md:block" />

        <div className="relative z-10 py-16 px-5 sm:px-6">
          <div className="mx-auto max-w-5xl">
            {/* Top bar */}
            <div className="mb-6 flex items-center gap-3">
              <div className="flex items-center gap-3">
                  <h1 className="text-2xl sm:text-3xl font-bold">{t('library.title')}</h1>
              </div>
              <div className="ml-auto flex items-center gap-2">
                <button onClick={openComingSoon} className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-2 text-sm text-slate-200 hover:bg-white/10">
                  <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="1.5" d="M12 3v12m0 0 4-4m-4 4-4-4M4 21h16"/></svg>
                  {t('library.newLibrary')}
                </button>
              </div>
            </div>

            {/* Info/intro */}
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-2xl mb-6">
                <p className="text-sm text-slate-300">{t('library.intro1')}</p>
                <p className="mt-2 text-xs text-slate-400">{t('library.intro2')}</p>
            </div>

      {/* Actions toolbar */}
            <div className="mb-6 flex flex-wrap items-center gap-2">
      <button onClick={openComingSoon} className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-xs sm:text-sm text-slate-200 hover:bg-white/10">
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="1.6" d="M12 5v14M5 12h14"/></svg>
    {t('actions.addDocuments')}
              </button>
              <button onClick={openComingSoon} className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-xs sm:text-sm text-slate-200 hover:bg-white/10">
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="1.6" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path strokeWidth="1.6" d="M7 10l5-5 5 5"/></svg>
                  {t('actions.importLink')}
              </button>
            </div>

            {/* List header */}
            <div className="flex items-center justify-between mb-3">
                <div className="text-slate-300 text-sm">{t('library.count', { count: 1 })}</div>
              <div>
                <select className="rounded-lg bg-white/5 border border-white/10 text-xs text-slate-300 px-2 py-1">
                  <option>{t('common.all')}</option>
                </select>
              </div>
            </div>

            {/* Libraries list (placeholder) */}
            <div className="rounded-2xl border border-white/10 bg-white/5 divide-y divide-white/10 overflow-hidden">
              <button onClick={openComingSoon} className="w-full text-left hover:bg-white/5 transition-colors">
                <div className="p-4 flex items-center gap-4">
                  <div className="h-9 w-9 rounded-lg bg-red-500/20 text-red-300 flex items-center justify-center">
                    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="1.6" d="M4 6h16v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"/><path strokeWidth="1.6" d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <div className="text-slate-100 font-medium truncate">{t('library.newLibrary')}</div>
                      <span className="ml-2 text-xs text-slate-400 hidden sm:inline">{t('library.lastUpdated')} • {new Date().toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' })}</span>
                    </div>
                    <div className="mt-1 text-xs text-slate-400 flex flex-wrap items-center gap-3">
                      <span>{t('library.noDocument')}</span>
                      <span className="opacity-50">•</span>
                      <span>0 Bytes</span>
                      <span className="opacity-50">•</span>
                        <span>{t('library.createdBy', { email })}</span>
                    </div>
                  </div>
                  <div className="text-slate-400">
                    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="1.5" d="M9 18l6-6-6-6"/></svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Coming soon modal */}
        {showModal && (
          <div className="fixed inset-0 z-[120] flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setShowModal(false)} />
            <div className="relative z-10 w-[92vw] max-w-md rounded-2xl border border-white/10 bg-slate-900/90 p-6 text-slate-200 shadow-2xl">
              <div className="flex items-center gap-3">
                <div className="h-9 w-9 rounded-lg bg-emerald-500/20 text-emerald-300 flex items-center justify-center">
                  <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeWidth="1.6" d="M4 19.5V6a2 2 0 0 1 2-2h9l5 5v10.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/></svg>
                </div>
                  <h3 className="text-lg font-semibold">{t('mcp.soonTitle')}</h3>
              </div>
              <p className="mt-3 text-sm text-slate-300">
                  {t('library.intro1')}
              </p>
                <p className="mt-2 text-xs text-slate-400">{t('mcp.soonText')}</p>
              <div className="mt-5 flex items-center justify-end gap-2">
                  <button onClick={() => setShowModal(false)} className="rounded-lg bg-white/5 px-4 py-2 text-sm text-slate-200 hover:bg-white/10">{t('common.close')}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
